<script>
import Loading from '../../components/loading.vue';
import AfterSale from '../../components/mineTable/afterSale.vue';
import MineOption from '../../components/select/mineOption.vue';
import MineSelect from '../../components/select/mineSelect.vue';

export default {
    name: "afterSale",
    data() {
        return {
            isLoading: false,
            detail: {
                goods: {}
            },
            type: [
                { text: '退款退货' },
            ],
            typeValue: '退款退货',
            reason: [
                { text: '质量问题' },
            ],
            reasonValue: '质量问题',
            content: '',
            images: [],
        };
    },
    computed: {},
    components: {
        Loading,
        MineSelect,
        MineOption,
        AfterSale,
    },
    mounted() {
        this.getOrderDetail();
    },
    destroyed() {},
    watch: {},
    methods: {
        // 服务类型
        typeChoose(item) { 
            this.typeValue = item.text;
        },
        // 退款原因
        reasonChoose(item) { 
            this.reasonValue = item.text;
        },
        // 获取文件信息
        getFileData(event) {
            const maxLength = 5;
            console.log(this.images.length);
            if (this.images.length >= maxLength) {
                this.$showToast({text: '最多上传'+ maxLength +'张图片'});
                return;
            }
            const files = this.$refs.file.files;
            Object.entries(files).slice(0, maxLength - this.images.length).forEach(([key, value]) => {
                // 读取文件
                let reader = new FileReader();
                reader.readAsDataURL(value);
                reader.onload = (result) => { 
                    this.images.push({
                        path: reader.result,
                        file: value,
                    });
                    this.$previewRefresh();
                    // console.log(result)
                    // console.log(reader.result)
                    // this.image = reader.result;
                }
            });
            // 清空input file value
            this.$refs.file.value = '';
        },
        // 获取订单详情
        getOrderDetail() { 
            this.isLoading = true;
            this.$store.dispatch('getShopOrderDetail', {
                order_code: this.$route.query.code
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) {
                    this.detail = result.data;
                    // this.detail.item = this.detail.item.map(v => ({
                    //     ...v,
                    //     total_price: (parseFloat(v.price) * v.qty).toFixed(2)
                    // }));
                    // 获取对应id的商品信息
                    const itemId = this.$route.query.id;
                    this.detail.goods = result.data.item.find(v => v.id == itemId);
                    this.detail.goods.total_price = (parseFloat(this.detail.goods.price) * this.detail.goods.qty).toFixed(2);
                } else if (result.code == 90) { 
                    this.toLogin();
                }
            }).catch((err) => {
                this.isLoading = false;
                this.$showToast({ text: err.message || '获取订单详情失败' });
            });
        },
        // 跳转登录
        toLogin() { 
            this.$router.push({
                path: '/login',
                query: {
                    redirect: this.$route.fullPath
                }
            })
        },
        // 提交申请
        submit() { 
            if (!this.typeValue) {
                this.$showToast({ text: '请选择服务类型' });
                return;
            }
            if (!this.reasonValue) {
                this.$showToast({ text: '请选择退款原因' });
                return;
            }
            if (!this.content.trim()) {
                this.$showToast({ text: '请填写退款说明' });
                return;
            }
            if (this.images.length == 0) {
                this.$showToast({ text: '请上传第三方证明' });
                return;
            }
            // 提交申请
            let formData = new FormData();
            formData.append('token', localStorage.getItem('token'));
            formData.append('order_code', this.detail.order_code);
            formData.append('id', this.detail.goods.id);
            formData.append('service_type', this.typeValue);
            formData.append('reason_type', this.reasonValue);
            formData.append('reason_desc', this.content.trim());
            this.images.forEach((item, idx) => {
                formData.append('proof_images[]', item.file, item.file.name || `img-${idx}.jpg`);
            });
            this.$store.dispatch('shopOrderAfterSale', formData).then((result) => {
                if (result.code == 100) {
                    this.$showToast({ text: '退货申请提交成功，等待审核' });
                    this.$router.go(-1);
                } else if (result.code == 90) { 
                    this.toLogin();
                } else {
                    this.$showToast({ text: result.msg || '提交失败' });
                }
            }).catch((err) => {
                this.$showToast({ text: err.message || '提交失败' });
            });
        },
    },
};
</script>

<template>
    <div class="after_sale">
        <p class="title">售后服务</p>
        <div class="loading_wrap" v-if="isLoading">
            <Loading/>
        </div>
        <!-- 商品信息 -->
        <AfterSale v-else :data="detail"/>
        <div class="form">
            <div class="item">
                <p class="name">服务类型：*</p>
                <MineSelect class="select" :value="typeValue">
                    <template v-slot:value>{{ typeValue }}</template>
                    <MineOption v-for="(item, index) in type" :key="index" :is-active="typeValue == item.text" @click="typeChoose(item)">{{ item.text }}</MineOption>
                </MineSelect>
            </div>
            <div class="item">
                <p class="name">退款原因：*</p>
                <MineSelect class="select" :value="reasonValue">
                    <template v-slot:value>{{ reasonValue }}</template>
                    <MineOption v-for="(item, index) in reason" :key="index" :is-active="reasonValue == item.text" @click="reasonChoose(item)">{{ item.text }}</MineOption>
                </MineSelect>
            </div>
            <div class="item">
                <p class="name">退款说明：*</p>
                <textarea placeholder="退款说明" v-model="content"></textarea>
            </div>
            <div class="item">
                <p class="name">第三方证明：*</p>
                <div class="images">
                    <div class="image" v-for="(item, index) in images" :key="index" :style="`background-image: url(${item.path});`">
                        <img :src="item.path" alt="" preview="images"/>
                        <div class="btn_close" @click="images.splice(index, 1)"></div>
                    </div>
                    <input type="file" ref="file" style="display: none;" accept="image/*" multiple @change="getFileData"/>
                    <div class="image add" v-if="images.length < 5" @click="$refs.file.click()"></div>
                </div>
            </div>
        </div>
        <div class="more_info">
            <p>备注：非质量问题不退不换，请谨慎购买，质量问题需提供第三方质检机构证明，提交后我方会尽快确认是否质量问题，并在第一时间以邮件或短信与您确认。请勿在确认前寄回，我司有权拒签货物。由于商品为艺术藏品和商品，限量或联名款，货物到达您手上请务必拆封检查，如遇货物在物流中的损毁，请立即拒绝签售，如您未检查并签售，我方不承担任何商品损坏所导致的损失。我方确认退换货申请后，请按照以上地址填写并包装立即寄回。如在通过后3个工作日未能寄出，退货申请将自动撤销，撤销后若超出保障期，将无法再次发起售后申请。请务必了解。</p>
            <p>由于商品质量原因导致的任何问题，我方承担所有国内物流费用。</p>
        </div>
        <div class="form">
            <div class="item justify_end">
                <div class="btn" @click="$router.go(-1)">取消申请</div>
                <div class="btn" @click="submit">提交</div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.after_sale{
    .more_info{
        padding: 0 .1rem;
        font-size: .14rem;
        line-height: 1.5;
        @media screen and (max-width: 750px) {
            font-size: .22rem;
            padding: 0;
        }
    }
    .form{
        padding: .3rem .1rem;
        @media screen and (max-width: 750px) {
            padding: .3rem 0;
        }
        .item{
            .name{
                width: 1.1rem;
                @media screen and (max-width: 750px) {
                    width: 1.7rem;
                }
            }
            .select{
                width: 2.2rem;
                flex: none;
            }
            .images{
                display: flex;
                flex-wrap: wrap;
                gap: .2rem;
                .image{
                    width: 1.2rem;
                    height: 1.2rem;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: cover;
                    position: relative;
                    img{
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        opacity: 0;
                    }
                    .btn_close{
                        width: .4rem;
                        height: .4rem;
                        position: absolute;
                        top: 0;
                        right: 0;
                        background: rgba($color: #000000, $alpha: .5);
                        cursor: pointer;
                        &::before,
                        &::after{
                            content: "";
                            display: block;
                            width: 50%;
                            border-bottom: 1px solid #fff;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%) rotate(45deg);
                        }
                        &::after{
                            transform: translate(-50%, -50%) rotate(135deg);
                        }
                    }
                    .loading{
                        margin: 0;
                    }
                    &.add{
                        border: 1px solid var(--font_color);
                        position: relative;
                        &::before,
                        &::after{
                            content: "";
                            width: 50%;
                            border-bottom: 1px solid var(--font_color);
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                        &::after{
                            transform: translate(-50%, -50%) rotate(90deg);
                        }
                    }
                }
            }
        }
    }
}
</style>